// 表单Y轴数据格式，直接返回series

// TrendChart1 使用
export function yDataFormat1(res, legend, YMDDateList) {
  let series = []
  res.forEach((item, index) => {
    let data = []
    YMDDateList.forEach((element) => {
      const result = item.find((e) => element === e.date)
      data.push(result ? result.quantity : 0)
    })
    series.push({
      name: legend[index],
      yAxisIndex: index === 4 ? 0 : 1,
      type: 'line',
      smooth: true,
      data,
    })
  })
  return series
}
export function yDataFormat2(chartData, legend, legendField, selected) {
  let series = []
  let xData = []
  let data = [[], [], []]

  function itemPush(item) {
    xData.push(item.country)
    data[0].push(item[legendField[0]])
    data[1].push(item[legendField[1]])
    data[2].push(item[legendField[2]])
  }

  // 图例改变，根据所选数值总和排序
  if (selected) {
    let count = new Array(chartData.length).fill(0)
    legend.forEach((item, index) => {
      if (selected[item]) {
        chartData.forEach((ele, i) => {
          count[i] += ele[legendField[index]]
        })
      }
    })
    // 排序
    for (let i = 0; i < count.length - 1; i++) {
      for (let j = 0; j < count.length - 1 - i; j++) {
        if (count[j] < count[j + 1]) {
          let tempCount, tempData
          tempCount = count[j]
          count[j] = count[j + 1]
          count[j + 1] = tempCount
          tempData = chartData[j]
          chartData[j] = chartData[j + 1]
          chartData[j + 1] = tempData
        }
      }
    }
    console.log(count)
  }
  chartData.forEach((item) => {
    itemPush(item)
  })
  data.forEach((item, index) => {
    series.push({
      name: legend[index],
      type: 'bar',
      barMaxWidth: '20%',
      data: item,
    })
  })
  return { series, xData }
}
